/* @ngInject */
const axletreeLabels = (
  wagonUtils
) => {
  const self = {}

  self.class = 'essieu'
  self.title = 'Essieux'

  self.fields = {
    position: {
      text: 'Position',
    },
    decision: {
      text: 'Décision',
    },
    number: {
      text: 'Numéro',
    },
    weight: {
      text: 'Poids (kg)',
    },
    type: {
      text: 'Type',
    },
    diameter: {
      text: 'Diamètre (cm)',
    },
    material: {
      text: 'Mesure relevée',
    },
    numberOf: {
      text: 'Nombre d\'essieu',
    },
    expeditionDate: {
      text: 'Date d\'expédition',
    },
    expeditionPlace: {
      text: 'Lieu d\'expédition',
    },
    wagonId: {
      text: 'Wagon',
    },
  }

  self.statements = {
    number: (_index) => {
      return 'Essieu N°' + _index
    },
    edit: (_myWagonId) => {
      return 'Gestion des essieux de ' + wagonUtils.idToString(_myWagonId)
    },
  }

  self.ask = {
    delete: 'Êtes vous sûr de vouloir supprimer ces essieux ?',
  }

  self.log = {
    search: {
      success: (_length = 0) => {
        if (_length === 0) {
          return 'Aucun essieu n\'a été trouvé.'
        } else if (_length === 1) {
          return '1 essieu a été trouvé.'
        } else {
          return _length + ' essieux ont été trouvés.'
        }
      },
      failure: 'Impossible de rechercher les essieux.',
    },
    save: {
      success: 'L\'essieu a bien été enregistré.',
      failure: 'Impossible de sauvegarder cet essieu.',
    },
    update: {
      success: 'L\'essieu a bien été modifié.',
      failure: 'Impossible de modifier cet essieu.',
    },
    delete: {
      success: 'L\'essieu a bien été supprimé.',
      failure: 'Impossible de supprimer cet essieu.',
    },
    saveAll: {
      success: (_length = 0) => {
        if (_length === 0) {
          return 'Aucun essieu à sauvegarder.'
        } else if (_length === 1) {
          return 'L\'essieu a bien été sauvegardé.'
        } else {
          return 'Les ' + _length + ' essieux ont été sauvegardés.'
        }
      },
      failure: 'Impossible de sauvegarder les essieux.',
    },
  }

  return self
}
export default axletreeLabels



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/axletree/resources/labels.resource.js